import { connect } from "react-redux";
import ApprovedSalesChallan from "./approvedSalesChallan";
import { bindActionCreators } from "redux";
import { getChallansForSite } from "services/redux/sales/approvedSalesListing/action";

const mapStateToProps = (state) => ({
  siteChallans: state.approvedSalesListReducer.siteChallans
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getChallansForSite,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedSalesChallan);
